import { tsUtils } from '@neo-one/ts-utils';
import { BuiltinInstanceMemberCall } from '../BuiltinInstanceMemberCall';
export class SetAdd extends BuiltinInstanceMemberCall {
    canCall(_sb, _func, node) {
        return tsUtils.argumented.getArguments(node).length === 1;
    }
    emitCall(sb, func, node, optionsIn, visited) {
        const options = sb.pushValueOptions(optionsIn);
        if (!visited) {
            sb.visit(tsUtils.expression.getExpression(func), options);
        }
        if (tsUtils.argumented.getArguments(node).length < 1) {
            return;
        }
        if (optionsIn.pushValue) {
            sb.emitOp(node, 'DUP');
        }
        sb.emitHelper(node, options, sb.helpers.unwrapMap);
        sb.visit(tsUtils.argumented.getArguments(node)[0], options);
        sb.emitPushBoolean(node, true);
        sb.emitOp(node, 'SETITEM');
    }
}

//# sourceMappingURL=add.js.map
